import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=1e8d2cd0&scoped=true&"
import script from "./TermsCondition.vue?vue&type=script&lang=js&"
export * from "./TermsCondition.vue?vue&type=script&lang=js&"
import style0 from "./TermsCondition.vue?vue&type=style&index=0&id=1e8d2cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8d2cd0",
  null
  
)

export default component.exports